import { Component } from '@angular/core';

@Component({
  selector: 'app-warning-popup',
  imports: [],
  templateUrl: './warning-popup.component.html',
  styleUrl: './warning-popup.component.less'
})
export class WarningPopupComponent {
    constructor(){}
}
